export default function validationReconductionContrat(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FORBIDDEN_ON_CLOSED_CONTRACT') === 0) {
      const code = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'listeContratReconductible.popUpReconduction.error.forbiddenOnClosedContract',
        parametres: {
          code: code,
        },
      });
    }
    if (message.indexOf('SHOULD_BE_RENEWABLE') === 0) {
      const code = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'listeContratReconductible.popUpReconduction.error.contractShouldBeRenewable',
        parametres: {
          code: code,
        },
      });
    }
    if (message.indexOf('SHOULD_HAVE_PAYMENT_TYPE_WITH_PURCHASE_ACTION') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeContratReconductible.popUpReconduction.error.bailleurModePaiement',
        parametres: { bailleur: elements[1] },
      });
    }
    if (message.indexOf('LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: 'listeContratReconductible.popUpReconduction.error.leastOneProduct',
      });
    }
  });
}
